export class Icone {
    classe: string;
    nome: string;

    constructor(iconeDto: any) {
        this.classe = iconeDto?.Classe;
        this.nome = iconeDto?.Nome;
    }
}
